import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import merge from 'lodash/merge'

import useSpeechBubbleStyles from './SpeechBubble.styles'
import { SpeechBubbleProps } from './SpeechBubble.types'

/**
 *
 * @description A decoractive speech bubble component used with an avatar
 * @param {SpeechBubbleProps} SpeechBubbleProps
 *
 */
const SpeechBubble = ({
  label = 'fully focus on your art...',
  children,
  direction,
  bubbleColor,
  parentColor,
  color,
  sx,
}: SpeechBubbleProps) => {
  const styles = useSpeechBubbleStyles({
    direction,
    color,
    bubbleColor,
    parentColor,
  })

  return (
    <Box sx={{ height: '100%' }}>
      <Typography component="p" variant="subtitle1" sx={merge(styles, sx)}>
        <span>{label || children}</span>
      </Typography>
    </Box>
  )
}

export default SpeechBubble
